// extracted by mini-css-extract-plugin
export default {"endingContent":"endingContent__SVVY5","endingDesc":"endingDesc__IzE-G","endingImgWrapper":"endingImgWrapper__YjS7l","endingWrapper":"endingWrapper__jX6C+"};